'use client'

import { SWR_OPTIONS } from 'my-purchases/constants/swrOptions'
import { SWRConfig } from 'swr'

export function SWRMyPurchasesProvider({
	children,
}: {
	children: React.ReactNode
}) {
	return <SWRConfig value={SWR_OPTIONS}>{children}</SWRConfig>
}
